module.exports = __webpack_public_path__ + "static/img/scancode.8b7f6dbe.png";